// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sup-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-width: 0;
}

.sup-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.sup-form__label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  line-height: 1.3;
}

.sup-form__req {
  color: #ef4444;
  font-weight: 600;
}

.sup-form .ant-form-item-label,
.sup-form .ant-form-item-feedback-icon {
  display: none !important;
}

.sup-form .ant-form-item-control-input {
  min-height: 36px !important;
}

.sup-form .ant-input-affix-wrapper,
.sup-form .ant-form-item-control-input-content > input.ant-input {
  box-sizing: border-box !important;
  width: 100% !important;
  height: 36px !important;
  min-height: 36px !important;
  margin: 0 !important;
  padding: 0 12px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  background: #ffffff !important;
  box-shadow: none !important;
  font-size: 14px !important;
  color: #0f172a !important;
}

.sup-form .ant-input-affix-wrapper input.ant-input {
  height: 100% !important;
  min-height: 0 !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
}

.sup-form .ant-input::placeholder {
  color: #94a3b8;
}

.sup-form .ant-input-affix-wrapper:hover,
.sup-form .ant-form-item-control-input-content > input.ant-input:hover {
  border-color: #cbd5e1 !important;
}

.sup-form .ant-input-affix-wrapper-focused,
.sup-form .ant-input-affix-wrapper:focus-within,
.sup-form .ant-form-item-control-input-content > input.ant-input:focus {
  border-color: #0ea5e9 !important;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15) !important;
}

.sup-form .ant-select {
  width: 100%;
}

.sup-form .ant-select .ant-select-selector {
  height: 36px !important;
  border-radius: 8px !important;
  border-color: #e2e8f0 !important;
  background: #ffffff !important;
  box-shadow: none !important;
  font-size: 14px !important;
}

.sup-form .ant-select .ant-select-selection-item,
.sup-form .ant-select .ant-select-selection-placeholder {
  line-height: 34px !important;
  font-size: 14px !important;
}

.sup-form .ant-select .ant-select-selection-placeholder {
  color: #94a3b8;
}

.sup-form .ant-select-focused .ant-select-selector {
  border-color: #0ea5e9 !important;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15) !important;
}

.sup-form .ant-form-item-has-error .ant-input-affix-wrapper,
.sup-form .ant-form-item-has-error .ant-form-item-control-input-content > input.ant-input,
.sup-form .ant-form-item-has-error .ant-select .ant-select-selector {
  border-color: #f43f5e !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/inventory/suppliers/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;;;EAGE,gCAAgC;AAClC","sourcesContent":[".sup-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n  min-width: 0;\n}\n\n.sup-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.sup-form__label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #334155;\n  line-height: 1.3;\n}\n\n.sup-form__req {\n  color: #ef4444;\n  font-weight: 600;\n}\n\n.sup-form .ant-form-item-label,\n.sup-form .ant-form-item-feedback-icon {\n  display: none !important;\n}\n\n.sup-form .ant-form-item-control-input {\n  min-height: 36px !important;\n}\n\n.sup-form .ant-input-affix-wrapper,\n.sup-form .ant-form-item-control-input-content > input.ant-input {\n  box-sizing: border-box !important;\n  width: 100% !important;\n  height: 36px !important;\n  min-height: 36px !important;\n  margin: 0 !important;\n  padding: 0 12px !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 8px !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n  font-size: 14px !important;\n  color: #0f172a !important;\n}\n\n.sup-form .ant-input-affix-wrapper input.ant-input {\n  height: 100% !important;\n  min-height: 0 !important;\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n}\n\n.sup-form .ant-input::placeholder {\n  color: #94a3b8;\n}\n\n.sup-form .ant-input-affix-wrapper:hover,\n.sup-form .ant-form-item-control-input-content > input.ant-input:hover {\n  border-color: #cbd5e1 !important;\n}\n\n.sup-form .ant-input-affix-wrapper-focused,\n.sup-form .ant-input-affix-wrapper:focus-within,\n.sup-form .ant-form-item-control-input-content > input.ant-input:focus {\n  border-color: #0ea5e9 !important;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15) !important;\n}\n\n.sup-form .ant-select {\n  width: 100%;\n}\n\n.sup-form .ant-select .ant-select-selector {\n  height: 36px !important;\n  border-radius: 8px !important;\n  border-color: #e2e8f0 !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n  font-size: 14px !important;\n}\n\n.sup-form .ant-select .ant-select-selection-item,\n.sup-form .ant-select .ant-select-selection-placeholder {\n  line-height: 34px !important;\n  font-size: 14px !important;\n}\n\n.sup-form .ant-select .ant-select-selection-placeholder {\n  color: #94a3b8;\n}\n\n.sup-form .ant-select-focused .ant-select-selector {\n  border-color: #0ea5e9 !important;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15) !important;\n}\n\n.sup-form .ant-form-item-has-error .ant-input-affix-wrapper,\n.sup-form .ant-form-item-has-error .ant-form-item-control-input-content > input.ant-input,\n.sup-form .ant-form-item-has-error .ant-select .ant-select-selector {\n  border-color: #f43f5e !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
